export default __webpack_public_path__ + "static/media/vpFire.fafe3288.svg";